import { cn } from '@/lib/utils/tailwind';

import type { ElementType, ReactNode, Ref } from 'react';

type ItemSuffixProps<T extends ElementType = 'span'> = {
  as?: T;
  className?: string;
  children: ReactNode;
  ref?: Ref<HTMLSpanElement>;
};

const ItemSuffix = <T extends ElementType = 'span'>({
  as,
  className,
  children,
  ref,
  ...props
}: ItemSuffixProps<T>) => {
  const Component = as || 'span';
  return (
    <Component className={cn('justify-end', className)} ref={ref} {...props}>
      {children}
    </Component>
  );
};

export { ItemSuffix, type ItemSuffixProps };
